export default "__VITE_ASSET__CDsTfp16__"